export default {
  'npm_package_version': '2019.38.1',
  'npm_package_forcesw': 'true',
  'npm_package_last_changes': '2019.38.1:<br/>- Übertragungsfehler behoben (Job bleibt in Synchronisation hängen)<br/><br/>2019.35.2:<br/>- Rahmen um Signaturfeld verändert<br/><br/>2019.35.1:<br/>- Ersatzteilabholung behoben: mehrere Ersatzteilabholungen funktionieren jetzt<br/>- Prüfung der Arbeitszeit<br/>- einige Anzeige-Änderungen'
};



// WEBPACK FOOTER //
// ./src/environments/.env.ts